import Slider from './Slider.vue'
import SliderScrollbar from './SliderScrollbar.vue'
import Slide from './Slide.vue'

export {
    Slider,
    SliderScrollbar,
    Slide
}
